import { useCallback, useEffect } from 'react';
import isEqual from 'lodash/isEqual';
export var useSelectPreset = function (_a) {
    var gridName = _a.gridName, gridActions = _a.gridActions, gridSelectors = _a.gridSelectors, setSelectedPresetName = _a.setSelectedPresetName, onClosePresetsModal = _a.onClosePresetsModal;
    var gridPresets = gridSelectors === null || gridSelectors === void 0 ? void 0 : gridSelectors.presets;
    var filters = gridSelectors === null || gridSelectors === void 0 ? void 0 : gridSelectors.filter;
    var handleSelectPreset = useCallback(function (presetName, filters) { return function () {
        var _a;
        setSelectedPresetName(presetName);
        (_a = gridActions.setFilters) === null || _a === void 0 ? void 0 : _a.call(gridActions, filters);
        onClosePresetsModal();
    }; }, [gridActions]);
    useEffect(function () {
        var _a;
        if (!gridName || !gridPresets)
            return;
        var activePreset = (_a = Object.entries(gridPresets)) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
            var presetName = _a[0], presetFilters = _a[1];
            return isEqual(presetFilters, filters);
        });
        if (activePreset) {
            setSelectedPresetName(activePreset[0]);
        }
        else {
            setSelectedPresetName('');
        }
    }, [filters, gridPresets]);
    return { handleSelectPreset: handleSelectPreset };
};
